import ToastNotification from "../../components/ToastNotification/ToastNotification";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaBell } from "react-icons/fa";
function Setting({
  userData
}) {
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const [refValue, setRefValue] = useState('');
  const [commision, setCommision] = useState('');
  const [gst, setGst] = useState('');
  const [qr, setQr] = useState(null);
  const [maxCoin, setMaxCoin] = useState('');
  const [fee, setFee] = useState('');
  const [notifyMess, setNotifyMess] = useState([]);
  useEffect(() => {
    if (userData) {
      setRefValue(userData.user_id || "");
      setCommision(userData.lat || "");
      setGst(userData.longi || "");
      setMaxCoin(userData.profile_pic || "");
      setFee(userData.name || "");
      if (userData.ref_code) {
        setQr(`https://api.sweepydo.in/uploads/${userData.ref_code}`);
      }
    }
  }, [userData]);
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("userData"));
    if (storedUser) {
      setRefValue(storedUser.user_id || "");
      setCommision(storedUser.lat || "");
      setGst(storedUser.longi || "");
      setMaxCoin(storedUser.profile_pic || '');
      setFee(storedUser.name || "");
      if (storedUser.ref_code) {
        setQr(`https://api.sweepydo.in/uploads/${storedUser.ref_code}`);
      }
    }
  }, []);
  const handleSaveCoin = async e => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("refValue", Number(refValue));
      formData.append("commision", Number(commision));
      formData.append("gst", Number(gst));
      formData.append('maxCoin', Number(maxCoin));
      formData.append('fee', fee);
      let newFileName = null;
      if (qr && typeof qr !== "string") {
        const maxSize = 2 * 1024 * 1024;
        if (qr.size > maxSize) {
          showToast("File too large!", "danger");
          return;
        }
        formData.append("ref_code", qr);
      }
      const res = await axios.put(`https://api.sweepydo.in/update-ref-value/${userData.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      newFileName = res.data.file;
      if (newFileName) {
        const newUrl = `https://api.sweepydo.in/uploads/${newFileName}`;
        setQr(newUrl);
      }
      const updatedUser = {
        ...userData,
        user_id: refValue,
        lat: commision,
        longi: gst,
        ref_code: newFileName || userData.ref_code,
        profile_pic: maxCoin,
        name: fee
      };
      localStorage.setItem("userData", JSON.stringify(updatedUser));
      showToast("Updated successfully!", "success");
    } catch (error) {
      console.error(error);
      showToast("Failed to update", "danger");
    }
  };
  const handleNotify = async () => {
    if (!notifyMess.trim()) {
      showToast("Please enter a message", 'warning');
      return;
    }
    try {
      const response = await axios.post("https://api.sweepydo.in/general-notification", {
        notifyMess: notifyMess
      });
      showToast(response.data.message || "Notification sent successfully", 'success');
      setNotifyMess("");
    } catch (error) {
      console.error(error);
      showToast(error.response?.data?.message || "Server Error", 'danger');
    }
  };
  return <div className="container-fluid mt-2" style={{
    minHeight: "100vh"
  }}>

      <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />

      <h2 className="heading mb-4">Setting</h2>

      <div className="row justify-content-center">
        <div className="col-12 col-md-10 col-lg-9">

          <div className="row g-3">

            <div className="col-md-7">
              <div className="custom-card p-4 h-100">

                <h5 className="mb-3">Update</h5>

                <form onSubmit={handleSaveCoin}>

                  <div className="mb-3">
                    <label className="form-label">Set Value</label>
                    <input type="text" className="form-control" value={refValue} onChange={e => setRefValue(e.target.value)} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Commission</label>
                    <input type="text" className="form-control" value={commision} onChange={e => setCommision(e.target.value)} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">GST</label>
                    <input type="text" className="form-control" value={gst} onChange={e => setGst(e.target.value)} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Set Maximum Reedom Coin</label>
                    <input type="text" className="form-control" value={maxCoin} onChange={e => setMaxCoin(e.target.value)} />
                  </div>

                   <div className="mb-3">
                    <label className="form-label">Set Platform Fee</label>
                    <input type="text" className="form-control" value={fee} onChange={e => setFee(e.target.value)} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Upload QR</label>

                    <input type="file" className="form-control" accept="image/*" onChange={e => {
                    const file = e.target.files[0];
                    if (file) {
                      const maxSize = 2 * 1024 * 1024;
                      if (file.size > maxSize) {
                        showToast("File size must be less than 2MB", "danger");
                        e.target.value = null;
                        return;
                      }
                      setQr(file);
                    }
                  }} />
                  </div>

                  <button type="submit" className="btn btn-success">
                    Save
                  </button>

                </form>

              </div>
            </div>

            {/* ✅ RIGHT CARD (IMAGE PREVIEW) */}
            <div className="col-md-5">
              <div className="custom-card p-4 h-100 d-flex flex-column align-items-center justify-content-center">

                <h6 className="mb-3">QR Preview</h6>

                <div style={{
                width: "100%",
                height: "220px",
                border: "1px dashed #ccc",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f9f9f9"
              }}>
                  {qr ? <img src={typeof qr === "string" ? qr : URL.createObjectURL(qr)} alt="QR" style={{
                  maxWidth: "100%",
                  maxHeight: "200px",
                  objectFit: "contain"
                }} /> : <span style={{
                  color: "#999"
                }}>No QR Uploaded</span>}
                </div>

              </div>
            </div>

             <div className="col-md-7 mb-3">
      <div className="custom-card p-4 h-100">
        <h3 className="mb-4">General Notification</h3>

        <div className="mb-3">
          <label className="form-label">Message</label>

          <textarea className="form-control" rows="5" placeholder="Enter notification message..." value={notifyMess} onChange={e => setNotifyMess(e.target.value)}></textarea>
        </div>

        {/* Center Button */}
        <div className="d-flex justify-content-center mt-4">
          <button className="btn btn-primary px-4 py-2" onClick={handleNotify}>
            <FaBell className="me-2" />
            Notify
          </button>
        </div>
      </div>
    </div>

          

          </div>

        </div>
      </div>

    </div>;
}
export default Setting;
